import { loadEndless } from "../common/utils.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// Tipologia di Programmi

	const filterTypologies = document.querySelectorAll(
		"ul.nav-typologies > li > a",
	);

	function reset_showtime() {
		for (const el of document.querySelectorAll(".channel__program")) {
			el.style.cssText = "display:grid !important";
		}
		for (const el of document.querySelectorAll("div.channel")) {
			el.style.cssText = "display:block !important";
		}
	}

	function filter_showtime_by_type(type) {
		if (type !== "all") {
			for (const el of document.querySelectorAll(
				`.channel__program:not(.typologies-${type})`,
			)) {
				el.style.cssText = "display:none !important";
				if (
					el.parentNode.querySelectorAll(
						'div.channel__program:not([style*="display: none !important;"])',
					).length === 0
				) {
					const parent_channel = el.closest("div.channel");
					if (parent_channel) {
						el.closest("div.channel").style.cssText = "display:none !important";
					}
				}
			}
		}
	}

	const handleFilterTypologiesClick = (e) => {
		e.preventDefault();
		for (const node of filterTypologies) {
			node.classList.remove("active");
		}
		e.currentTarget.classList.add("active");
		reset_showtime();
		filter_showtime_by_type(e.currentTarget.dataset.typologies);
	};
	for (const node of filterTypologies) {
		node.addEventListener("click", handleFilterTypologiesClick);
	}

	// Callback Endless Pagination
	// Filtro, se attivo, per tipologia di showtime
	if (document.querySelector("body").dataset.paginated === "true") {
		loadEndless().then((endlessPaginate) => {
			endlessPaginate({
				onCompleted: (context, fragment) => {
					history.pushState(null, "", context.url);
					const currentTypologies = document.querySelector(
						"ul.nav-typologies > li > a.active",
					);
					filter_showtime_by_type(currentTypologies.dataset.typologies);
					save_current_channel();
				},
			});
		});
	}

	// Gestione scroll al canale visualizzato prima di cliccare sul link di dettaglio
	function save_current_channel() {
		const external_links = document.querySelectorAll("a._showtime_link");
		for (const el of external_links) {
			el.addEventListener("click", (e) => {
				window.localStorage.setItem("ChannelHashtag", `#${el.dataset.channel}`);
			});
		}
	}
	save_current_channel();
	const gotToChannel = window.localStorage.getItem("ChannelHashtag");
	if (gotToChannel) {
		const channelNode = document.querySelector(gotToChannel);
		if (channelNode) {
			scroll({
				top: channelNode.offsetTop - 80,
				behavior: "smooth",
			});
		}
		window.localStorage.removeItem("ChannelHashtag");
	}

	// Filtro canali on click
	const channel_filter = document.getElementById("_channel_filter");
	if (channel_filter) {
		channel_filter.addEventListener("click", () => {
			const dropdown = channel_filter.querySelector(".dropdown-menu");
			if (!!dropdown.querySelector("a._channel") === false) {
				for (const channel of MOVIE_CHANNELS) {
					const channel_link = document.createElement("a");
					channel_link.classList.add("dropdown-item", "_channel");
					if (channel.active) {
						channel_link.classList.add("active");
					}
					channel_link.href = channel.link;
					channel_link.text = channel.name;
					dropdown.appendChild(channel_link);
				}
			}
		});
	}
});
